import React from 'react';
import styled from 'styled-components';
import { formatDate } from '../../utils/DateHelper';
import { IEvent } from '../../graphql/schema/p4types';

const Container = styled.div<{ last?: boolean }>`
  padding: 8px 16px;
  border-bottom: ${(props) => (props.last ? 'none' : `1px solid ${props.theme.colors.grey40}`)};
`;

const Status = styled.div<{ closed?: boolean }>`
  padding: 2px 4px;
  background-color: ${(props) => (props.closed ? '#00b9af' : '#ffffff')};
  color: #fff;
  border-radius: 3px;
  font-weight: 600;
  font-size: 10px;
  width: max-content;
`;

const StatusContainer = styled.div`
  width: 50px;
  display: inline-block;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #000;
  display: inline-block;
`;

const CommentContainer = styled.div`
  padding-left: 50px;
  font-size: 12px;
  color: #000;
  display: block;
`;

const Comment = styled.div`
  display: inline-block;
  width: 50%;
`;

const CommentType = styled.div`
  display: inline-block;
  width: 50%;
  text-align: right;
`;

const OverviewEventField = ({
  eventStart,
  closed,
  eventType,
  subject,
  last,
}: {
  last?: boolean;
} & IEvent) => {
  return (
    <Container last={last}>
      <StatusContainer>{closed ? <Status closed={true}>Closed</Status> : null}</StatusContainer>
      <Title>{subject}</Title>
      <CommentContainer>
        <Comment>{formatDate(eventStart)}</Comment>
        <CommentType>{eventType?.description}</CommentType>
      </CommentContainer>
    </Container>
  );
};

export default OverviewEventField;
